module.exports = __webpack_public_path__ + "static/media/photography07.91f50c95.png";